import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

// Assets Imports
import LogoImg from '../assets/logo.jpg'; 
import callIcon from '../assets/phone-icon.png'; 
import mailIcon from '../assets/email-icon.png';

const Navbar = ({ onPortalClick }) => { // onPortalClick prop එක එකතු කළා
  const [isOpen, setIsOpen] = useState(false);

  const navLinks = [
    { name: 'Home', href: '#home' },
    { name: 'Courses', href: '#courses' },
    { name: 'Teachers', href: '#teachers' },
    { name: 'Contact', href: '#contact' },
  ];

  return (
    <header className="fixed w-full z-[100] shadow-md">
      
      {/* --- TOP BAR (Clickable Contacts) --- */}
      <div 
        className="text-white py-2.5 px-4 sm:px-8 border-b border-white/5"
        style={{ backgroundColor: 'rgb(49 46 129)' }}
      >
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          
          <div className="flex items-center space-x-5 md:space-x-10">
            {/* Phone */}
            <a href="tel:+94771234567" className="flex items-center space-x-2.5 group cursor-pointer">
              <img src={callIcon} alt="Call" className="w-5 h-5 md:w-6 md:h-6 brightness-0 invert transition-transform group-hover:scale-110" />
              <span className="text-[10px] md:text-[13px] font-bold tracking-tight md:tracking-wide group-hover:text-yellow-400 transition-colors">077 123 4567</span>
            </a>

            {/* Email */}
            <a href="mailto:info@vidulaka.lk" className="flex items-center space-x-2.5 group cursor-pointer">
              <img src={mailIcon} alt="Email" className="w-5 h-5 md:w-6 md:h-6 brightness-0 invert transition-transform group-hover:scale-110" />
              <span className="text-[10px] md:text-[13px] font-bold tracking-tight md:tracking-wide group-hover:text-yellow-400 transition-colors">info@vidulaka.lk</span>
            </a>
          </div>

          <div className="flex items-center space-x-2 ml-4">
             <span className="bg-red-600 text-white px-1.5 py-0.5 rounded-full text-[8px] md:text-[9px] font-black animate-pulse shadow-lg shadow-red-900/20">LIVE</span>
             <span className="text-white font-black text-[9px] md:text-[10px] uppercase tracking-tighter md:tracking-widest">2026 Admissions Open</span>
          </div>
        </div>
      </div>

      {/* --- MAIN NAVBAR --- */}
      <nav className="bg-white px-4 sm:px-8 border-b border-gray-100">
        <div className="max-w-7xl mx-auto flex justify-between h-20 items-center">
          
          {/* --- LOGO SECTION --- */}
          <a href="#home" className="flex-shrink-0 flex items-center group cursor-pointer no-underline">
            <img 
              src={LogoImg} 
              alt="Vidulaka Logo" 
              className="h-12 w-12 md:h-16 md:w-16 rounded-full border-2 border-red-600/10 shadow-sm transition-transform duration-500 group-hover:scale-105" 
            />
            <div className="ml-3">
               <h1 className="text-lg md:text-xl font-black text-indigo-950 leading-none group-hover:text-red-600 transition-colors">VIDULAKA</h1>
               <p className="text-[9px] md:text-xs font-bold text-red-600 tracking-[0.2em] uppercase mt-0.5">Matale Campus</p>
            </div>
          </a>

          {/* Desktop Nav Links */}
          <div className="hidden md:flex space-x-8 items-center font-bold">
            {navLinks.map((link) => (
              <a key={link.name} href={link.href} className="text-gray-700 hover:text-red-600 transition-colors text-sm uppercase tracking-wider">
                {link.name}
              </a>
            ))}
            
            {/* PORTAL LOGIN BUTTON - DESKTOP */}
            <button 
              onClick={onPortalClick} 
              className="bg-red-600 text-white px-6 py-2.5 rounded-full hover:bg-red-700 shadow-lg shadow-red-100 transition-all font-bold text-sm uppercase tracking-widest active:scale-95"
            >
               Login
            </button>
          </div>

          {/* Mobile Menu Icon */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-indigo-950 p-2 focus:outline-none">
              <div className="w-7 h-5 relative flex flex-col justify-between overflow-hidden">
                <motion.span animate={isOpen ? { rotate: 45, y: 8 } : { rotate: 0, y: 0 }} className="w-full h-1 bg-current rounded-full origin-left" />
                <motion.span animate={isOpen ? { opacity: 0, x: 20 } : { opacity: 1, x: 0 }} className="w-full h-1 bg-current rounded-full" />
                <motion.span animate={isOpen ? { rotate: -45, y: -8 } : { rotate: 0, y: 0 }} className="w-full h-1 bg-current rounded-full origin-left" />
              </div>
            </button>
          </div>
        </div>

        {/* --- MOBILE DROPDOWN MENU --- */}
        <AnimatePresence>
          {isOpen && (
            <motion.div
              initial={{ opacity: 0, height: 0 }}
              animate={{ opacity: 1, height: 'auto' }}
              exit={{ opacity: 0, height: 0 }}
              className="md:hidden bg-white border-t border-gray-100 overflow-hidden shadow-2xl"
            >
              <div className="flex flex-col space-y-4 p-8 font-bold text-gray-700 uppercase tracking-widest text-[12px]">
                {navLinks.map((link) => (
                  <a key={link.name} href={link.href} onClick={() => setIsOpen(false)} className="hover:text-red-600 transition-colors border-b border-gray-50 pb-3">{link.name}</a>
                ))}
                
                {/* PORTAL LOGIN BUTTON - MOBILE */}
                <button 
                  onClick={() => {
                    setIsOpen(false);
                    onPortalClick();
                  }}
                  className="bg-red-600 text-white px-6 py-4 rounded-xl shadow-md w-full font-bold uppercase tracking-widest active:scale-95"
                >
                  Portal Login
                </button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </nav>
    </header>
  );
};

export default Navbar;